<nav class="navbar navbar-expand-lg navbar-dark fixed-top">
  <div class="container">

    <a class="navbar-brand d-flex align-items-center header-container" routerLink="/">
      <!-- Image gauche -->
      <img [src]="logo"
          (error)="onImageError($event)"
          alt="Armoirie"
          class="logo">

    </a> 

    <!-- Bouton mobile -->
    <button class="navbar-toggler" type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarContent">
      <span class="navbar-toggler-icon"></span>
    </button>

    <!-- Contenu -->
    <div class="collapse navbar-collapse" id="navbarContent">

      <!-- Liens alignés à droite -->
      <ul class="navbar-nav ms-auto align-items-lg-center">

        <!-- <li class="nav-item">
          <a class="nav-link active" routerLink="/">Accueil</a>
        </li> -->


        <li class="nav-item">
          <a class="nav-link" routerLink="/contact">Contact</a>
        </li>

        <li class="nav-item ms-lg-3">
          <a routerLink="/login"
             class="btn btn-primary btn-login d-flex align-items-center">
            <i class="fas fa-sign-in-alt me-2"></i>
            Connexion
          </a>
        </li>

      </ul>
    </div>
  </div>
</nav>


<!-- Style CSS -->

<!-- Script pour l'effet de scroll -->
<script>
document.addEventListener('DOMContentLoaded', function() {
  const navbar = document.querySelector('.navbar');

  window.addEventListener('scroll', function() {
    if (window.scrollY > 50) {
      navbar.classList.add('scrolled');
    } else {
      navbar.classList.remove('scrolled');
    }
  });
});
</script>
